<template>
    <v-card :dark="dark" style="height: 100%" class="course-card" :class="{'bordered': !dark}">
        <div
            class="course-card-thumb e-link"
            role="img"
            :aria-label="'صورة كورس ' + course.name"
            :style="{ backgroundImage: `url(${course.image_url})` }"
            @click="$router.push({name: 'course', params: {id: course.id}})"
            v-ripple
        />
        <div class="course-card-body px-3 py-3">
            <div v-if="showCourseMeta" class="mb-1 details-text muted--text">
                <span v-if="course.pay_type === 'course' && platform !== 'ios'">
                    <b v-if="course.price === 0" class="secondary--text">مجانية</b>
                    <b v-else class="primary--text">{{moneyFormat(course.price, true)}}</b>
                </span>

                <v-chip v-if="course.featured" label outlined small dark color="orange darken-1" class="ms-1" style="height: 20px; padding: 0 6px;">
                    <v-icon size="15" class="me-1">mdi-star</v-icon>
                    <span>مميز</span>
                </v-chip>
            </div>
            <div class="course-title" :class="{'sm-title': short}">
                <router-link :class="{'strong-text--text': !dark, 'white--text': dark}" style="text-decoration: none" :to="{name: 'course', params: {id: course.id}}">
                    {{course.name}}
                </router-link>
            </div>
            <div class="course-card-footer">
                <div class="d-flex justify-space-between">
                    <v-chip color="primary" small>
                        <div class="small-text d-flex align-center">
                            <v-icon color="white" small class="me-2">mdi-play-circle-outline</v-icon>
                            {{unitFormat(course.lectures_count, 'محاضرة', 'محاضرتين', 'محاضرات')}}
                        </div>
                    </v-chip>
                    <v-chip v-if="course.users_count" color="primary" small>
                        <div class="small-text d-flex align-center">
                            <v-icon color="primary" small class="me-2">mdi-account-group-outline</v-icon>
                            {{unitFormat(course.users_count, 'طالب', 'طلاب', 'طلاب')}}
                        </div>
                    </v-chip>
                </div>
            </div>
        </div>
        <!-- <v-card-text v-if="!short" class="pt-0 px-4">
            <div class="categories">
                <v-chip v-for="category in course.categories" color="surface2" :key="category.id" label small class="me-2 mb-1">{{category.name}}</v-chip>
            </div>
        </v-card-text> -->
    </v-card>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        course: {},
        short: {type: Boolean, default: false},
        dark: {type: Boolean, default: false}
    },
    components: {},
    data(){
        return {
            
        }
    },
    computed: {
        free(){
            return this.course && this.course.pay_type === 'course' && this.course.free;
        },
        showCourseMeta(){
            const showPrice = this.course && this.course.pay_type === 'course' && this.platform !== 'ios';
            return showPrice || !!(this.course && this.course.featured);
        },
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods
    }
}
</script>

<style lang="scss" scoped>
.course-card.v-card{
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
    transition: 0.2s ease all;
    border-radius: 12px!important;
    overflow: hidden;
    padding: 8px;
    cursor: pointer;

    &:hover{
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(0, 35, 91, 0.12)!important;
    }

    .course-card-thumb {
        width: 100%;
        aspect-ratio: 3 / 2;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-color: #0a1628;
        border-radius: 8px;
        overflow: hidden;
        transition: transform 0.35s ease;
        cursor: pointer;
        flex: 0 0 auto;
    }

    &:hover .course-card-thumb {
        transform: scale(1.02);
    }

    .course-card-body {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
    }

    .course-title {
        flex: 1 1 auto;
        min-height: calc(1.4em * 2);
        margin-top: 0.15rem;
        line-height: 1.4;
        font-size: 1.15rem;

        &.sm-title{
            font-size: 1.08rem;
        }

        a{
            display: block;
            text-decoration: none;
            white-space: normal;
            overflow: visible;
            word-break: break-word;
            overflow-wrap: anywhere;
        }
    }

    .course-card-footer {
        margin-top: 1.1rem;
        flex: 0 0 auto;
    }
}
</style>